
























































































































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import HttpClient from "@/API/HttpClient";
import Utils from "@/store/utils";
import httpApi from "@/API/Tenant/Weixin";
import { format } from "path";
import Bus from "@/JS/Bus";
//import App from "@/components/Global/GetAppData"; //缓存接口
import { log } from "util";
import { WxTextImg } from "@/Entity"; //全局常量
import { getCookie } from "@/JS/cookie"; //使用getCookie方法
@Component({
  components: {}
})
export default class extends Vue {
  @Provide()
  private GetAppData: any = {}; //取应用号信息
  private pagesize = 10; //每页的数据条数
  private pageIndex = 1; // 默认第一页
  private inboxTabData: any = [];
  private totalItem = 0; //数据总长度
  private TextTabData = []; //表格
  private EventClickEdit = true;
  private dialogVisible = false;
  private scrollHeight = 500; //当前高度
  private appletVisible = false;
  private loading = false; //加载数据
  //功能库相关
  private libraryview = false;
  private LibraryTabData = [];
  private templateSelection: any;
  private search: string = "";
  private libraryPagesize = 10; //每页的数据条数
  private libraryPageIndex = 1; // 默认第一页
  private libraryTotalItem: number = 0;
  private tableName: string = "AppReplyGraphic";
  private Nature: string = "1";

  private Keyword: string = "";

  private loadingText = "数据正在同步中，请稍后.....";
  private AddaccountForm: any = {
    Keyword: "",
    State: "1",
    Type: "1",
    Contents: ""
  }; //定义数据
  private AddappletForm: any = {
    link: "",
    appid: "",
    path: "",
    nickname: ""
  };
  //功能库
  async library() {
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      let params: any = {
        Input: [
          { Name: "aid", value: AppAccount.Aid },
          { Name: "TableName", value: this.tableName },
          { Name: "Nature", value: this.Nature },
          { Name: "SortId", value: 0 },
          { Name: "State", value: "1" }
        ]
      };
      // console.log(params);
      var res: any = await httpApi.KeyAll(params);
      if (res.ErrorCode == 0) {
        this.LibraryTabData = res.output[0].value;
        const search = this.search;
        if (search) {
          //console.log(search);
          this.LibraryTabData = res.output[0].value.filter(
            (x: {
              Keyword: {
                toUpperCase: () => { indexOf: (arg0: string) => number };
              };
            }) => x.Keyword.toUpperCase().indexOf(search.toUpperCase()) != -1
          );
        }
        //this.libraryTotalItem = this.LibraryTabData.length;
        this.loadData();
      } else {
        this.$message.error(res.ErrorMessage);
      }
      // console.log(res);
    }
    this.libraryview = true;
  }
  //查看文章
  handleView(index: any, row: any) {
    if (row.Link) {
      //window.open(row.UrlLink);
      window.open(row.Link, "newwin");
    } else {
      this.$message.error("请先拉取公众号文章！");
    }
  }
  //分页方法数据
  loadData() {
    if (this.LibraryTabData) {
      this.inboxTabData = this.LibraryTabData.slice(
        (this.libraryPageIndex - 1) * this.libraryPagesize,
        this.libraryPageIndex * this.libraryPagesize
      );
      this.libraryTotalItem = this.LibraryTabData.length;
    }
  }
  //分页方法
  private libraryhandleClick() {}
  private libraryhandleSizeChange(val: any) {
    this.libraryPagesize = val;
    this.library();
  }
  private libraryhandleCurrentChange(val: any) {
    this.libraryPageIndex = val;
    this.library();
  }
  libraryhandleCurrentTableChange(val: any) {
    console.log(val);
    this.templateSelection = val;
    this.AddaccountForm.Remark = val.Keyword;
    this.AddaccountForm.TableName = val.TableName;
  }
  //格式化时间
  formatDate(row: any, column: any) {
    if (row.UpdaterDate != null && row.UpdaterDate != "") {
      // var date = new Date(row.UpdaterDate);
      // return FomatDataStr.formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      var date = row.UpdaterDate;
      date = date.replace("T", " ");
      date = date.substring(0, 19);
      return date;
    } else {
      return "";
    }
  }
  //当前选中
  getTemplateRow(index: any, row: any) {
    //获取选中数据
    this.templateSelection = row;
    this.AddaccountForm.Remark = row.Keyword;
    this.AddaccountForm.TableName = row.TableName;
  }
  //功能库确定
  librarycheck() {
    if (!this.templateSelection) {
      this.$message.error("请先选择一条记录，再确定！");
    } else {
      this.libraryview = false;
    }
    //console.log(this.templateSelection);
    this.Keyword = this.templateSelection.Keyword;
    this.AddaccountForm.Contents = JSON.stringify(this.templateSelection);
  }
  //功能库取消
  libraryclose() {
    this.templateSelection = undefined;
    this.AddaccountForm.Url = "";
    this.libraryview = false;
  }
  //验证文本关键词
  rulesApplet = {
    link: [
      { required: true, message: "请输入链接文字", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    nickname: [
      { required: true, message: "请输入小程序名称", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    appid: [
      { required: true, message: "请输入小程序appid", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    path: [
      { required: true, message: "请输入小程序路径", trigger: "blur" },
      { min: 1, max: 100, message: "长度在 1 到 100 个字符", trigger: "blur" }
    ]
  };
  rules = {
    Keyword: [
      { required: true, message: "请输入关键词", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    Title: [
      { required: true, message: "请输入标题", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    Type: [
      { required: true, message: "请输选择类型", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ],
    Contents: [
      { required: true, message: "请输入内容", trigger: "blur" },
      { min: 1, max: 2000, message: "长度在 1 到 2000 个字符", trigger: "blur" }
    ],
    State: [
      { required: true, message: "请输选择状态", trigger: "blur" },
      { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" }
    ]
  };
  //初始化
  created() {
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };
    this.getList();
    this.scrollHeight = document.body.scrollHeight - 440;
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      that.GetAppData.Aid = obj.Aid;
      that.getList();
    });
  }
  //查询数据列表
  async getList() {
    var _this = this;
    //console.log(this.GetAppData);
    let AppAccount = this.GetAppData;
    if (AppAccount) {
      //搜索的数据 传参
      let params: any = {
        Input: [
          { Name: "Aid", value: AppAccount.Aid },
          //分页参数
          { Name: "page", value: this.pageIndex },
          { Name: "rows", value: this.pagesize }
        ]
      };
      var res: any = await httpApi.GetAppReplyRecordListAsync(params);
      if (res.ErrorCode == 0) {
        _this.TextTabData = res.output[0].value;
        _this.totalItem = res.output[1].value;
      } else {
        this.$message.error(res.ErrorMessage);
      }
    }
  }
  //分页方法
  private handleClick() {}
  private handleSizeChange(val: any) {
    this.pagesize = val;
    this.getList();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = val;
    this.getList();
  }
  //格式化状态
  formatState(row: any, column: any) {
    switch (row.State) {
      case 1:
        return "启用";
      case 0:
        return "禁用";
      case -1:
        return "删除";
    }
  }
  //增加事件对话框
  AddEventClickEdit() {
    this.AddappletForm = {
    link: "",
    appid: "",
    path: "",
    nickname: ""
  }
  this.AddaccountForm = {
    Keyword: "",
    State: "1",
    Type: "1",
    Contents: ""
  }
    this.dialogVisible = true;
  }
  //修改数据
  handleEdit(index: any, row: any) {
    this.AddaccountForm = row; //把行信息传给data
    this.dialogVisible = true;
    this.AddaccountForm.State = String(this.AddaccountForm.State);
    this.AddaccountForm.Type = String(this.AddaccountForm.Type);
  }
  //单行删除
  async handleDel(index: any, row: any) {
    this.$confirm("确定要删除当前数据吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(async () => {
      let model = row; //把行内信息转换成wxText
      var _this = this;
      let AppAccount = this.GetAppData;

      if (AppAccount) {
        model.ApplicationId = AppAccount.Aid;
        model.TenantId = AppAccount.TenantID;
        model.ActionName = "DELETE";
        let params: any = {
          Input: [
            {
              Name: "AppEventClickDTO",
              value: model
            }
          ]
        };
        var res: any = await httpApi.AppEventClickUpdateAsync(params);
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.getList();
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      }
    });
  }
  //关闭对话框
  handleClose() {
    this.$confirm("确认关闭？")
      .then(_ => {
        this.dialogVisible = false;
        this.getList();
      })
      .catch(_ => {});
  }
  //关闭小程序对话框
  appletHandleClose() {
    this.appletVisible = false;
    this.dialogVisible = true;
  }
  //生成小程序文本链接
  appletHandleClick() {
    var _this = this;
    (_this as any).$refs["AddappletForm"].validate(async (valid: boolean) => {
      if (valid) {
        var appletHtml =
          '<a class="weapp_text_link js_weapp_entry"  data-miniprogram-appid="' +
          _this.AddappletForm.appid +
          '" data-miniprogram-path="' +
          _this.AddappletForm.path +
          '" data-miniprogram-nickname="' +
          _this.AddappletForm.nickname +
          '" href="" data-miniprogram-type="text" data-miniprogram-servicetype="" _href="">' +
          _this.AddappletForm.link +
          "</a>"; //合成小程序链接
        _this.AddaccountForm.Contents += appletHtml;
        _this.appletHandleClose();
      }
    });
  }
  //保存数据
  save() {
    var _this = this;
    (_this as any).$refs["AddaccountForm"].validate(async (valid: boolean) => {
      if (valid) {
        let AppAccount = this.GetAppData;

        if (AppAccount) {
          this.AddaccountForm.ApplicationId = AppAccount.Aid;
          this.AddaccountForm.TenantId = AppAccount.TenantID;
        }
        if (this.AddaccountForm.EventClickId) {
          this.AddaccountForm.ActionName = "UPDATE"; //修改方法
        } else {
          this.AddaccountForm.ActionName = "CREATE"; //新增方法
        }
        let params: any = {
          Input: [
            {
              Name: "AppEventClickDTO",
              value: this.AddaccountForm
            }
          ]
        };
        _this.loading = true;
        var res: any = await httpApi.AppEventClickUpdateAsync(params);
        _this.loading = false;
        if (res.ErrorCode == 0) {
          this.$message.success("保存成功!");
          _this.dialogVisible = false;
          this.getList();
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      }
    });
  }
}
